<template>
  <v-list>
    <template v-for="(item, i) in items">
      <v-list-item
        :key="i"
        v-on="$listeners.select ? { click: () => $emit('select', item) } : {}"
      >
        <avatar
          :image="item.image"
          :name="item.image ? '' : item.name"
          list
        />
        <v-list-item-content>
          <v-list-item-title>
            {{ item.name }}
          </v-list-item-title>
          <v-list-item-subtitle v-if="item.sub1 || item.sub2">
            {{ item.sub1 }}<br>{{ item.sub2 }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action v-if="$listeners.edit">
          <v-btn
            icon
            @click="(e) => {e.stopPropagation(); $emit('edit', item)}"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-list-item-action>
        <v-list-item-action v-if="$listeners.delete">
          <v-btn
            icon
            @click="(e) => {e.stopPropagation(); $emit('delete', item)}"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
  export default {
    props: {
      items: {
        type: Array,
        default: () => []
      }
    }
  }
</script>
